export default "__VITE_ASSET__BeLsQLGE__"